﻿import {
  NavigationApi,
  NavigationStackInfo,
  NavigateToGameOptions,
  PushAppOptions,
  QuitOptions,
} from './NavigationApi'
import { RundotGameAPI } from '../rundot-game-api/types'
import { createMockDelay, MOCK_DELAYS } from '../rundot-game-api/systems/core'
import { mockLog } from '../MockDebug'

const TAG = 'Mock Navigation'

export class MockNavigationApi implements NavigationApi {
  private readonly rundotGameApi: RundotGameAPI

  constructor(rundotGameApi: RundotGameAPI) {
    this.rundotGameApi = rundotGameApi
  }
  async requestPopOrQuit(options?: QuitOptions): Promise<boolean> {
    return true
  }

  getStackInfo(): NavigationStackInfo {
    const rundotGameApi = this.rundotGameApi
    const info: NavigationStackInfo = {
      isInStack: rundotGameApi._mock.stackState.isInStack,
      stackPosition: rundotGameApi._mock.stackState.stackPosition,
      isTopOfStack: rundotGameApi._mock.stackState.isTopOfStack,
      stackDepth: rundotGameApi._mock.stackState.stackDepth,
      parentInstanceId: rundotGameApi._mock.stackState.parentInstanceId,
    }
    return info
  }

  async popApp(): Promise<void> {
    const rundotGameApi = this.rundotGameApi
    // Check if we can pop
    if (rundotGameApi._mock.stackState.stackDepth <= 1) {
      console.warn('[RUN:mock] Cannot pop - at base of stack or not in stack')
      return
    }

    // Simulate delay
    await createMockDelay(MOCK_DELAYS.short)

    const poppedApp = rundotGameApi._mock.stackState.stackHistory.pop()
    mockLog(TAG, 'popApp', poppedApp)
    rundotGameApi._mock.stackState.stackDepth--
    rundotGameApi._mock.stackState.stackPosition = Math.max(
      0,
      rundotGameApi._mock.stackState.stackDepth - 1,
    )

    // Update stack state
    if (rundotGameApi._mock.stackState.stackDepth === 0) {
      rundotGameApi._mock.stackState.isInStack = false
      rundotGameApi._mock.stackState.isTopOfStack = false
      rundotGameApi._mock.stackState.parentInstanceId = null
    }

  }

  async pushApp(appId: string, options?: PushAppOptions): Promise<void> {
    const rundotGameApi = this.rundotGameApi

    // Simulate delay for mock
    await createMockDelay(MOCK_DELAYS.medium)

    // Update mock stack state
    rundotGameApi._mock.stackState.stackHistory.push({
      appId,
      pushedAt: Date.now(),
      contextData: options?.contextData,
      appParams: options?.appParams,
    })

    rundotGameApi._mock.stackState.isInStack = true
    rundotGameApi._mock.stackState.stackDepth++
    rundotGameApi._mock.stackState.stackPosition =
      rundotGameApi._mock.stackState.stackDepth - 1
    rundotGameApi._mock.stackState.isTopOfStack = true
    mockLog(TAG, `pushApp appId=${appId}`)
  }

  async navigateToGame(targetGameId: string, options?: NavigateToGameOptions): Promise<void> {
    await createMockDelay(MOCK_DELAYS.medium)
    mockLog(TAG, `navigateToGame targetGameId=${targetGameId}`, {
      hasLaunchContext: !!options?.launchContext,
      hasReturnContext: !!options?.returnContext,
    })
  }
}
